import React from "react";
import NavBar from "@/components/navigation/NavBar";
import HeroSection from "@/components/Landingpage/HeroSection";
import DetailsLp from "@/components/Landingpage/DetailsLp";
import ImmobillienAngebot from "@/components/Landingpage/ImmobillienAngebot";
import Vorteile from "@/components/Landingpage/Vorteile";
import CallToAction from "@/components/Landingpage/CallToAction";
import Footer from "@/components/navigation/Footer";
import CtaContact from "@/components/calltoaction/CtaContact";
import GoogleReviewsWidget from "@/components/Landingpage/GoogleRating";
import CategoryCarousel from "@/components/blogs/BlogWidget";
import Reveal from "@/components/Motion/Reveal";
import VorteileLandingpage from "@/components/Motion/VorteileLandingpage";
import CtaSuchprofil from "@/components/Landingpage/CtaSuchprofil";
import FaqSection from "@/components/navigation/faq";

export default function Landingpage() {
  return (
    <div className="font-serif">
      <NavBar className="bg-opacity-100 font-sans " />
      <div className="">
      <div className="md:hidden  pt-[2rem]">
          <img 
            src="/Fotos/landingpage-hero.webp" 
            alt="Hero Bild von Leon Jakobs am Blausteinsee Eschweiler" 
            fetchpriority="high"
          />
        </div>

        <div className=" md:bg-[url(/Fotos/landingpage-hero_desktop.webp)] bg-cover bg-center  relative flex justify-center">
        
          <div className="relative max-w-[95rem] md:rounded-none rounded-2xl md:translate-y-0 -translate-y-10 z-20 bg-white md:bg-transparent px-2 mx-auto ">
          
            <HeroSection />
          </div>

          <div className="h-[30rem] hidden md:block w-full absolute bottom-0 left-0 bg-gradient-to-b from-transparent from-40% to-gray-800/70 z-0"></div>        </div>
        
        <div className=" px-2 py-20 bg-gray-50 clipPath">
          <VorteileLandingpage />
        </div>
        <Reveal>
          <div className="bg-white pt-10">
        <Reveal>

            <DetailsLp />
            </Reveal>
            <Reveal>

            <ImmobillienAngebot  />
            </Reveal>

          </div>
        </Reveal>
        <div className="">
          <div className="py-14 bg-prime-900 clipPath">
            <Reveal>
              <Vorteile />
            </Reveal>
          </div>
        </div>

        {/* <div className='py-10'>
            <CtaBewerten />
          </div> */}
        <div className="md:py-32 pt-20">
          <CallToAction />
        </div>

        <div className="pb-10 md:pb-20 ">
          <GoogleReviewsWidget />
        </div>
        <div className="bg-gray-50 my-10 mb-16">
          <div className=" max-w-[80rem] mx-auto">
            <CtaSuchprofil />
          </div>
        </div>
        <div className="">
          <CategoryCarousel />
        </div>
<div className="bg-gradient-to-b from-prime-50 to-gray-50 h-10">

</div>
        <div className="bg-gray-50">
          <CtaContact className="py-20" />
        </div>
        <div>
          <FaqSection  faqArt="verkaufen"/>
        </div>
      </div>
      <Footer />
    </div>
  );
}
